import { InstaImage, InstaProfileINT } from "../../src/components/insta/interfaces";
import Game from "../../src/shell/Game";
import Question from "../../src/shell/Questions";
import { store } from "../../src/store/store";
import { alex } from "../characters/Alex";
import { alexImages } from "./alexInstaImages";
import { getImagePost, getInstaImage, getInstaProfile, random, setMinLikes } from "./helpers";


const currentOrNotIncludedScene = (scene: string) => {
    return Game.currentScene === scene && !Game.seenScenarios.includes(scene);
};
export const alexConditions: { [key: number]: { condition: (() => boolean), order?: number; }; } = {

    43: { condition: () => (Question.globalAnswers.v9ToldAlexToPostHerPic) },
    45: { condition: () => (!Question.globalAnswers.v9AlexDateRiskyPhoto) },
    46: { condition: () => (Question.globalAnswers.v9AlexDateRiskyPhoto) },
    47: { condition: () => (Question.globalAnswers.v9AlexDatePierTookInstaPhoto) },
};
function alexImagesStoryLogic(image: InstaImage, index: number) {


    // if (index > 13) {
    //     return false;
    // }


    if (Game.currentScene === 'v1VanessaDontVisit') {
        if (index > 1) { return false; }
        image.likes = 1;
    }
    if (Game.currentScene === 'v1AfterMeetings') {
        if (index > 2) { return false; }
    }
    if (Game.currentScene === 'v1BeforeEnding') {
        if (index > 3) { return false; }

        image.likes = setMinLikes(image.likes, 3, 5);
    }
    if (Game.currentScene === 'atHomeRoutine1') {
        if (index > 4) { return false; }
        image.likes = setMinLikes(image.likes, 5, 35);
    }
    if (Game.currentScene === 'eveningRoutine1') {
        if (index > 5) { return false; }
        image.likes = setMinLikes(image.likes, 35, 50);
    }
    if (Game.currentScene === 'beforeTruthDare') {
        if (index > 8) { return false; }

        image.likes = setMinLikes(image.likes, 50, 400);
    }
    if (Game.currentScene === 'AfterTODBtns1') {
        if (index > 9) { return false; }
        image.likes = setMinLikes(image.likes, 250, 400);
    }
    if (Game.currentScene === 'RoomAfterRecapBTNS') {
        if (index > 13) { return false; }
        image.likes = setMinLikes(image.likes, 450, 600);
    }
    if (Game.currentScene === 'RoomAfterEventsBTNS') {
        if (index > 14) { return false; }
        image.likes = setMinLikes(image.likes, 550, 800);
        if (!Game.seenScenarios.includes(`RoomAfterEventsBTNS`)) {
            if (index === 14) { image.likes + 1800; }
        }
    }
    if (Game.currentScene === 'ClubEventInstaCheck') {
        if (index > 15) { return false; }
        image.likes = setMinLikes(image.likes, 550, 800);
        if (!Game.seenScenarios.includes(`ClubEventInstaCheck`)) {
            if (index === 15) { image.likes + 450; }
        }
    }
    if (Game.currentScene === 'homeCheckInsta') {
        if (index > 18) { return false; }

        image.likes = setMinLikes(image.likes, 2000, 3500);
    }
    if (Game.currentScene === 'AfterClubEndDay') {
        if (index > 19) { return false; }

        image.likes = setMinLikes(image.likes, 3500, 4500);
    }
    if (Game.currentScene === 'V5HomeAfterVanessaHome') {
        if (index > 22) { return false; }

        image.likes = setMinLikes(image.likes, 5500, 10000);
    }
    if (Game.currentScene === 'V5AfterBeachJoeyOrEmilyAloneNoEvents') {
        if (index > 23) { return false; }
        image.likes = setMinLikes(image.likes, 5500, 10000);

    }
    if (Game.currentScene === 'V5HomeAfterVanessaAnn') {
        if (index > 24) { return false; }
        image.likes = setMinLikes(image.likes, 10000, 20000);
        if (!Game.seenScenarios.includes(`V5HomeAfterVanessaAnn`)) {
            if (index === 23) { image.likes += 2500; }
        }
    }
    if (Game.currentScene === 'V5EndDay2') {
        if (index > 25) { return false; }
        image.likes = setMinLikes(image.likes, 15000, 40000);
        if (!Game.seenScenarios.includes(`V5EndDay2`)) {
            if (index === 25) { image.likes += 7000; }
        }
    }
    if (Game.currentScene === 'V6EmilysRoomQuestion') {
        if (index > 27) { return false; }
        image.likes = setMinLikes(image.likes, 50, 500);

    }
    if (Game.currentScene === 'V6HomeRecap') {
        if (index > 30) { return false; }
        image.likes = setMinLikes(image.likes, 50, 500);

    }
    if (Game.currentScene === 'V6EndDay') {

        image.likes = setMinLikes(image.likes, 15000, 40000);
        if (index > 32) { return false; }

    }
    if (Game.currentScene === 'V7MCRoomWait') {
        if (index > 33) { return false; }
        image.likes = setMinLikes(image.likes, 3500, 5000);

    }
    if (Game.currentScene === 'V7MCRoomWait2') {
        if (index > 34) { return false; }
        image.likes = setMinLikes(image.likes, 5000, 10000);

    }
    if (Game.currentScene === 'V7EndDay') {
        if (index > 36) { return false; }
        image.likes = setMinLikes(image.likes, 20000, 50000);

    }
    if (Game.currentScene === 'V8MCRoomMorning') {
        if (index > 37) { return false; }
        image.likes = setMinLikes(image.likes, 25000, 50000);

    }
    if (Game.currentScene === 'V8EndDay1') {
        if (index > 38) { return false; }
        image.likes = setMinLikes(image.likes, 55000, 80000);

    }
    if (Game.currentScene === 'V8Day2_Events') {
        if (index > 40) { return false; }
        image.likes = setMinLikes(image.likes, 150000, 2500000);

    }
    if (Game.currentScene === 'V8Day2EndDay2') {
        image.likes = setMinLikes(image.likes, 150000, 2500000);
        if (index > 41) { return false; }

    }
    if (Game.currentScene === 'V9Events') {
        image.likes = setMinLikes(image.likes, 150000, 2500000);
        if (!Game.seenScenarios.includes(`V9VanessaMCBusNight`)) {
            if (index > 42) { return false; }
        } else {
            if (index > 44) { return false; }

        }

    }
    if (Game.currentScene === 'V9EndDay2Morning') {
        image.likes = setMinLikes(image.likes, 450000, 7500000);
        if (index > 44) { return false; }

    }
    if (Game.currentScene === 'V9EndDay2') {
        image.likes = setMinLikes(image.likes, 650000, 8500000);
        if (index > 47) { return false; }

    }

    const num = image.key.split(alex.key)[1];
    if (Object.keys(alexConditions).includes((num))) {
        const order = Object.keys(alexConditions).indexOf((num)) + 1;

        image.order = alexConditions[Number(num)].order || order;

        return alexConditions[Number(num)].condition();
    }
    return true;
};
// TODO: make insta helper for Alex like Ann has
function alexProfileStoryLogic(): Partial<InstaProfileINT> {
    const profiles = store.getState().insta.present.profiles;

    return {
        description: alex.properties.instaDescription,
        followers: alex.properties.instaFollowers,
        following: alex.properties.instaFollowing,
        instaProfileImage: alex.properties.instaProfileImage,
    };
}

export const alexInstaPhotos = (): InstaProfileINT => {

    return {
        ...getInstaProfile(alex, alexProfileStoryLogic()),
        images: [
            ...Object.keys(alexImages).map((image, index) => getAlexImagesPost(index + 1)),
        ].filter((image, index) => alexImagesStoryLogic(image, index + 1)).reverse()
        // .map(image => ({ ...image, likes: image.likes + 200 }))
    } as InstaProfileINT;
};

export const getAlexInstaData = (postNum: number) => {
    return new Array(postNum).fill(1).reduce((previous, current, index: number) => {
        return [...previous, getAlexImagesPost(index + 1)];
    }, []);


};

export const getAlexImagesPost = (id: number, options?: Partial<InstaImage>) => {
    return getImagePost(alexImages, store.getState().insta.present?.profiles?.[alex.key], `${alex.key}${id}`, options);
};
